import { Indikator } from './indikator.model';
import { UeberkategorieFilter } from './user/ueberkategorie-filter.model';
import { Synopse } from './ws/synopse.model';

export class ErgebnisStorage {
  indikatoren: Indikator[];
  ueberkategorieFilter: UeberkategorieFilter[];
  synopsen: Synopse[];
  isBegleitIndikator: boolean;
  sumFilter: number;
  sumFilterBegleitindikatoren: number;
}
